const NotFoundPage = () => {
    return (
        <div>
            <h1>Not Found</h1>
            <p>Sorry, there's nothing here.</p>
        </div>
    );
};

export default NotFoundPage;